import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BackIcon = ({ ...rest }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return location.key !== "default" ? (
    <i
      className="fas fa-arrow-circle-left fa-2x me-2 d-print-none"
      {...rest}
      style={{ color: "#f0ad4e" }}
      title="back"
      onClick={() => {
        if (location.state?.previousPath) {
          const state = {};
          switch (location.state.previousPath.split("/")[1].toLowerCase()) {
            case "allcaseloads":
              state.selectedProgram = location.state.selectedProgram;
              break;
            case "client":
              state.tab = location.state.tab;
              state.selectedProgram = location.state.selectedProgram;
              break;
            case "fosterhomes":
              state.tab = location.state.tab;
              state.home = location.state.home;
              state.addresses = location.state.addresses;
              break;
          }
          navigate(-1, {
            replace: true,
            state: state,
          });
        } else navigate(-1);
      }}
    ></i>
  ) : null;
};

export default BackIcon;
